export const AI_PROMPT_CHARACTER_LIMIT = 500;

export const DEBOUNCE_DELAY = 50;

export const AI_REQUEST_FREE_TIER_LIMIT = 5;

export const MAX_IMAGE_FILES = 2;
export const MAX_IMAGE_FILE_SIZE = 4 * 1024 * 1024; // 4MB
export const MAX_SVG_FILE_SIZE = 1 * 1024 * 1024; // 1MB

export const MAX_FREE_THEMES = 10;
